import React, {ReactElement} from 'react';
import {Button} from '@material-ui/core';

const ButtonField = (props: any): ReactElement => {
  const {buttonText, className, onClick, ...rest} = props;
  return (
    <Button
      variant="outlined"
      className={className}
      onClick={onClick}
      {...rest}>
      {buttonText}
    </Button>
  );
};

export default ButtonField;
